function DemoUserIcon({ className }) {
  return (
    <svg className={className} fill="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  );
}

export default function ProfileAvatar({ src, alt = 'Profile', className = '', iconClassName = 'h-1/2 w-1/2 text-white' }) {
  if (src) {
    return <img src={src} alt={alt} className={className} />;
  }

  return (
    <div
      className={`flex items-center justify-center bg-gradient-to-br from-[#D4C4F5] to-[#9369CC] ${className}`}
      aria-hidden={alt === 'Profile'}
    >
      <DemoUserIcon className={iconClassName} />
    </div>
  );
}
